module.exports = __webpack_public_path__ + "static/media/no_kid-grey.989ac2ea.png";